import React, { useState } from 'react'
import {
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Tooltip,
    Switch,
    Divider,
} from '@mui/material'
import { Icon, ViewIcon, LanguageIcon, WorkflowsIcon } from 'packages/eid-icons'
import { IconBrowser } from 'packages/eid-ui'
import NativeWorkflowBrowser from '../NativeWorkflowBrowser'
import { useAppState } from 'appContext'

const DevToolsMenu = () => {
    const [anchorEl, setAnchorEl] = useState(null)
    const [iconBrowserOpen, setIconBrowserOpen] = useState(false)
    const [workflowBrowserOpen, setWorkflowBrowserOpen] = useState(false)
    const [{ debugLocalization }, dispatch] = useAppState()

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleOpenIconBrowser = () => {
        setIconBrowserOpen(true)
        handleClose()
    }

    const handleCloseIconBrowser = () => {
        setIconBrowserOpen(false)
    }

    const handleOpenWorkflowBrowser = () => {
        setWorkflowBrowserOpen(true)
        handleClose()
    }

    const handleCloseWorkflowBrowser = () => {
        setWorkflowBrowserOpen(false)
    }

    const handleToggleDebugLocalization = () => {
        dispatch({
            type: 'SET_DEBUG_LOCALE',
            payload: !debugLocalization,
        })
        // Don't close the menu when toggling debug localization
    }

    return (
        <>
            <Tooltip title="Developer Tools">
                <IconButton
                    onClick={handleClick}
                    size="small"
                    sx={{ color: 'inherit' }}
                >
                    <Icon
                        name="Settings"
                        style={{ width: '20px', height: '20px' }}
                    />
                </IconButton>
            </Tooltip>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    sx: { minWidth: 200 },
                }}
            >
                <MenuItem onClick={handleOpenIconBrowser}>
                    <ListItemIcon>
                        <ViewIcon />
                    </ListItemIcon>
                    <ListItemText primary="Icon Browser" />
                </MenuItem>

                <MenuItem onClick={handleOpenWorkflowBrowser}>
                    <ListItemIcon>
                        <WorkflowsIcon />
                    </ListItemIcon>
                    <ListItemText primary="Workflow Browser" />
                </MenuItem>

                <Divider />

                <MenuItem
                    onClick={handleToggleDebugLocalization}
                    sx={{ py: 0 }}
                >
                    <ListItemIcon>
                        <LanguageIcon />
                    </ListItemIcon>
                    <ListItemText
                        primary="Debug Localization"
                        secondary={debugLocalization ? 'Enabled' : 'Disabled'}
                    />
                    <Switch
                        checked={debugLocalization}
                        onChange={handleToggleDebugLocalization}
                        size="small"
                    />
                </MenuItem>
            </Menu>

            <IconBrowser
                open={iconBrowserOpen}
                onClose={handleCloseIconBrowser}
            />
            <NativeWorkflowBrowser
                open={workflowBrowserOpen}
                onClose={handleCloseWorkflowBrowser}
            />
        </>
    )
}

export default DevToolsMenu
